// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1oQ4S","label":"CategoryService_label__3sNKh","location":"CategoryService_location__2Owmh"};